export const SET_TASK_LIST = "SET_TASK_LIST";
export const SET_TASK_DETAILS = "SET_TASK_DETAILS";
